import { DanceEventsInterface } from '../../..';

export class CreateFacebookEventRequestDto implements DanceEventsInterface{
  url: string;
  
  constructor(url: string) {
    this.url = url;
  }
}
